import { useId } from "react";
import { useTranslation } from "react-i18next";
import SourceDiff from "../../../ui/content/source/SourceDiff";

/** The unit's statements as N-Triples, off by default (`t`), as Daniel's viewer shows
 * "Technische Details" (curation-ui.md CU-3). */
export default function TechnicalDetails({
  added,
  removed,
  addedCount,
  removedCount,
}: {
  added: readonly string[];
  removed: readonly string[];
  addedCount: number;
  removedCount: number;
}) {
  const { t } = useTranslation();
  const headingId = useId();
  const hidden = addedCount + removedCount - added.length - removed.length;
  return (
    <section aria-labelledby={headingId} className="space-y-1">
      <h4 id={headingId} className="app-subsection-title text-sm">{t("reviews.curation.technical")}</h4>
      <SourceDiff label={t("reviews.curation.technical")} language="turtle" original={removed.join("\n")} modified={added.join("\n")} />
      {hidden > 0 ? <p className="app-text-muted text-xs">{t("reviews.curation.technicalMore", { count: hidden })}</p> : null}
    </section>
  );
}
